import { render, staticRenderFns } from "./btcost.vue?vue&type=template&id=53316251&"
import script from "./btcost.vue?vue&type=script&lang=js&"
export * from "./btcost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports